<script>
    import constants from './../../constants.js';

    export default {
        data() {
            return {
                constants: constants
            }
        },
        props: {
            type: {
                type: String,
                default: 'project'
            }
        }
    }
</script>

<template>
    <div class="card is-block is-fullheight">
        <div class="card-image is-clipped is-relative">
            <picture class="image is-clipped is-skeleton">
                <img src="https://placehold.co/411x294?text= " alt="Loading image" width="411" height="294" loading="lazy" onerror="this.onerror=null; this.style.backgroundColor='#cccccc'">
            </picture>
            <span class="tag is-light" v-if="type === constants.card.type.project || type === constants.card.type.partner">.........</span>
        </div>
        <div class="card-content is-flex-grow-1 is-flex is-flex-direction-column">
            <h4 class="title is-4">
                <progress class="progress" max="100"></progress>
            </h4>
            <div v-if="type === constants.card.type.project || type === constants.card.type.partner" class="mb-4">
                <span class="tag is-white">
                    <span class="icon"><i class="fa-solid fa-location-dot"></i></span>
                    <span>............</span>
                </span>
            </div>
            <progress class="progress is-small is-grey-light" max="100" v-if="type === constants.card.type.partner"></progress>
        </div>
    </div>
</template>
